import { FC } from "react";

interface IconProps {
  size?: number;
}

export const ZapBadgeIcon: FC<IconProps> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.64206 2L3.16406 9.33333H7.9974L7.35273 14L12.8307 6.66667H7.9974L8.64206 2Z"
      fill="#F8AD21"
    />
  </svg>
);

export const LikeBadgeIcon: FC<IconProps> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 3.80864C8.45933 3.2713 9.254 2.66797 10.464 2.66797C12.5807 2.66797 14 4.65464 14 6.50464C14 10.372 9.18533 13.3346 8 13.3346C6.81467 13.3346 2 10.372 2 6.50464C2 4.65464 3.41933 2.66797 5.536 2.66797C6.746 2.66797 7.54067 3.2713 8 3.80864Z"
      fill="#FF403D"
    />
  </svg>
);

export const PurchaseBadgeIcon: FC<IconProps> = ({ size = 16 }) => (
  <svg
    width={(size * 16) / 13}
    height={size}
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#wbadge_clip)">
      <path
        d="M1.2832 5.59375L3.99382 10.8214C4.15605 11.1343 4.60588 11.1276 4.75878 10.8101L7.27032 5.59375"
        stroke="url(#wbadge_p0)"
        strokeWidth="2.56591"
        strokeLinecap="round"
      />
      <path
        d="M8.33984 11.151L11.5472 4.30859"
        stroke="url(#wbadge_p1)"
        strokeWidth="2.56591"
        strokeLinecap="round"
      />
      <path
        d="M12.9556 0.946171C13.0853 0.860466 13.2602 0.937382 13.2847 1.09087L14.0945 6.167C14.1212 6.33417 13.9522 6.46457 13.7973 6.39642L8.699 4.15445C8.54404 4.0863 8.52595 3.87366 8.66718 3.78032L12.9556 0.946171Z"
        fill="#20CBFF"
      />
    </g>
    <defs>
      <linearGradient
        id="wbadge_p0"
        x1="4.27676"
        y1="5.59375"
        x2="4.27676"
        y2="11.5809"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#284EA0" />
        <stop offset="1" stopColor="#2399D6" />
      </linearGradient>
      <linearGradient
        id="wbadge_p1"
        x1="9.94354"
        y1="4.30859"
        x2="9.94354"
        y2="11.151"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#284EA0" />
        <stop offset="1" stopColor="#2399D6" />
      </linearGradient>
      <clipPath id="wbadge_clip">
        <rect width="16" height="13" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
